import { render, staticRenderFns } from "./PlaceholdersList.vue?vue&type=template&id=307a114e&"
import script from "./PlaceholdersList.vue?vue&type=script&lang=js&"
export * from "./PlaceholdersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports